addEventListener('DOMContentLoaded', (event) => {

  /* ===============================
     WISHLIST INITIAL LOAD
  =============================== */

  $(".wishlist-custom-action").each(function() {
    var attr = $(this).attr("data-handle");

    if (localStorage.getItem('wishlist')) {
      var existing_wishlist = JSON.parse(localStorage.getItem('wishlist'));

      if ($.inArray(attr, existing_wishlist) >= 0) {
        $(this).addClass('active-wishlist');
        $(this).removeClass('wishlist-custom-action');
      }

      $('.wishlist-counter').text(existing_wishlist.length);
    } else {
      $('.wishlist-counter').text('0');
    }
  });

  /* ===============================
     ADD TO WISHLIST
  =============================== */

  jQuery(document).on('click', '.wishlist-custom-action', function(e) {
    e.preventDefault();

    var value = $(this).attr('data-handle');
    var wishlist_pro = localStorage.getItem("wishlist")
      ? JSON.parse(localStorage.getItem('wishlist'))
      : [];

    if ($.inArray(value, wishlist_pro) === -1) {
      wishlist_pro.push(value);
    }

    localStorage.setItem('wishlist', JSON.stringify(wishlist_pro));
    localStorage.setItem('user_wishlist_cnt', wishlist_pro.length);

    $(this).removeClass('wishlist-custom-action').addClass('active-wishlist');
    $(".wishlist[data-handle='"+value+"']")
      .removeClass('wishlist-custom-action')
      .addClass('active-wishlist');

    $('.wishlist-counter').text(wishlist_pro.length);
  });

  /* ===============================
     REMOVE FROM WISHLIST
  =============================== */

  jQuery(document).on('click', '.active-wishlist', function(e) {
    e.preventDefault();

    var to_delete = $(this).attr('data-handle');
    var wishlist_pro = localStorage.getItem("wishlist")
      ? JSON.parse(localStorage.getItem('wishlist'))
      : [];

    var index = wishlist_pro.indexOf(to_delete);

    if (index > -1) {
      wishlist_pro.splice(index, 1);
    }

    localStorage.setItem('wishlist', JSON.stringify(wishlist_pro));
    localStorage.setItem('user_wishlist_cnt', wishlist_pro.length);

    $(this).removeClass('active-wishlist').addClass('wishlist-custom-action');
    $(".wishlist[data-handle='"+to_delete+"']")
      .removeClass('active-wishlist')
      .addClass('wishlist-custom-action');

    $('.wishlist-counter').text(wishlist_pro.length);
  });

  /* ===============================
     PRODUCT CARD IMAGE SLIDER
  =============================== */

  document.querySelectorAll('.product-card-slider').forEach(function(el) {
    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      allowTouchMove: true,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true
      }
    });
  });

});